<!-- группы можно вынести в toast-group c учетом параметров,
принимающихся сервисом, можно добавлять/редактировать параметры при необходимости
-->
@let groups = toastService.toastGroups.$ | async;

@for (group of currentGroups$ | async; track $index) {
    <div
        [class]="'bazis-toast-group bazis-toast-group_' + group"
        [part]="'group ' + group"
        popover="manual"
        #popoverToastGroup
    >
        @for (toast of groups[group]; track $index) {
            <div
                [ngClass]="['bazis-toast', toast.cssClass]"
                [part]="'toast ' + toast.type"
            >
                @if (toast.icon) {
                    <div
                        class="bazis-toast__icon"
                        part="icon"
                    >
                        <bazis-sign-status [color]="toast.color">
                            <bazis-icon
                                slot="icon"
                                [name]="toast.icon"
                            ></bazis-icon>
                        </bazis-sign-status>
                    </div>
                }
                <div
                    class="bazis-toast__content"
                    *transloco="let t"
                >
                    @if (toast.title) {
                        <div
                            class="bazis-toast__title"
                            [part]="'title ' + toast.type + (toast.timer ? ' timer' : '')"
                            [innerHTML]="toast.title"
                        >
                        </div>
                    }
                    @if (toast.titleKey) {
                        <div
                            class="bazis-toast__title"
                            [part]="'title ' + toast.type + (toast.timer ? ' timer' : '')"
                            [innerHTML]="t(toast.titleKey, toast.titleParams)"
                        ></div>
                    }

                    @if (toast.message) {
                        <div
                            class="bazis-toast__message"
                            part="message"
                            [innerHTML]="toast.message"
                        >
                        </div>
                    }
                    @if (toast.messageKey) {
                        <div
                            class="bazis-toast__message"
                            part="message"
                            [innerHTML]="t(toast.messageKey, toast.messageParams)"
                        ></div>
                    }
                    @if (toast.timer?.canBeCancel) {
                        <bazis-link
                            borderStyle="none"
                            size="compact"
                            (click)="cancelTimer(toast.timer, toast.id, group)"
                        >
                            @if (toast.timer.cancelLinkIcon) {
                                <bazis-icon
                                    slot="start"
                                    [icon]="toast.timer.cancelLinkIcon"
                                ></bazis-icon>
                            }
                            {{ t('action.cancel') }}
                        </bazis-link>
                    }
                </div>
                @if (toast.timer) {
                    <bazis-timer
                        [type]="toast.timer.type ? toast.timer.type : 'circle'"
                        [startValue]="toast.timer.startValue"
                        [circleOptions]="
                            toast.timer.circleOptions ? toast.timer.circleOptions : { radius: 10 }
                        "
                        [part]="'timer ' + (toast.type ? toast.type : toast.timer.color)"
                        [color]="toast.timer.color ? toast.timer.color : 'action'"
                        (afterStopTimer)="dismiss(toast.id, group)"
                    ></bazis-timer>
                } @else {
                    <button
                        class="bazis-toast__close"
                        [part]="'close ' + toast.type"
                        (click)="dismiss(toast.id, group)"
                    >
                        <bazis-icon [icon]="toast.closeIcon"></bazis-icon>
                    </button>
                }
            </div>
        }
    </div>
}
